import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import SeprateCard from '../Components/SeprateCard';
import { getCurrentUser } from '../utils/NewAuthService';

const SeprateCourses = () => {
  const [user_metadata, setUser_metadata] = useState([]);

  const isJson = (str) => {
    try {
      JSON.parse(str);
    } catch (e) {
      return false;
    }
    return true;
  };

  const getUserDetails = async () => {
    const user = await getCurrentUser();
    if (isJson(user.courseName)) {
      let dict_user_metadata = [];
      JSON.parse(user.courseName).forEach((elem, index) => {
        dict_user_metadata.push({
          courseName: elem,
          role: JSON.parse(user.roles)[index],
        });
      });
      setUser_metadata(dict_user_metadata);
    } else {
      let dict_user_metadata = [];
      dict_user_metadata.push({
        courseName: user.courseName,
        role: user.roles,
      });
      setUser_metadata(dict_user_metadata);
    }
  };
  useEffect(()=>{
    getUserDetails()
  }, []);
  return (
    <div className='bg-custom-1'>
      <Container>
        <Row>
          <Col className='p-3'>
            <h1 className='text-dark'>Available Courses</h1>
            <hr />
          </Col>
        </Row>
        <Row>
          {user_metadata
            ? user_metadata.map((elem, index) => {
                return (
                  <Col className='my-2 ' md={4}>
                    <SeprateCard name={elem.courseName} role={elem.role} />
                  </Col>
                );
              })
            : null}
        </Row>

        <div className='text-center my-2'>
          <a
            className='bg-custom-1 text-muted'
            target='_blank'
            rel='noreferrer'
            href='mailto:utech.onlineschool@gmail.com'
          >
            having problem finding your course ? contact @ utech
          </a>
        </div>
      </Container>
    </div>
  );
};

export default SeprateCourses;
